module.exports = __webpack_public_path__ + "img/bicycle.274cf791.svg";